import { css } from "@emotion/react";
import { Font, Button, Loader } from "@moneyforward/mfx_biz_react_components";
import { useRouter } from "next/router";
import { TAB } from "./ContractManagementPage";
import { PlanCancellationStepper } from "@/components/atoms/PlanCancellationStepper";
import Spacer from "@/components/atoms/utilities/Spacer";
import { PageTitle } from "../molecules";
import { MainTemplate } from "../templates";
import config from "@/libs/config";
import useFeatureFlags from "@/libs/hooks/useFeatureFlags";

export const PlanCancelCompletedPage = () => {
  const {
    featureFlags,
    loading: featureFlagLoading,
    error: featureFlagError,
  } = useFeatureFlags();
  const router = useRouter();

  // --------------------------------------------------
  // Conditional Rendering
  // --------------------------------------------------
  if (featureFlagLoading) {
    return <Loader>Loading ...</Loader>;
  }

  if (featureFlagError) {
    return (
      <div>
        <p>Error: {featureFlagError.message}</p>
      </div>
    );
  }

  return (
    <MainTemplate
      title={`${config.BANK_NICKNAME} Mikatano シリーズ サービス一覧`}
    >
      <PageTitle
        mainTitle={"解約を受け付けました"}
        subTitle={
          <Font variant="l">
            今月末まで引き続きサービスをご利用いただけます。
            <br />
            解約を取消す場合は、契約管理画面より解約の取消しができます。
            <br />
            <br />
            ご利用ありがとうございました。
          </Font>
        }
      >
        {featureFlags.CollectCancelReason.Enabled && (
          <>
            <Spacer size={32} />
            <PlanCancellationStepper step={3} />
          </>
        )}
      </PageTitle>
      <div css={button}>
        <Button
          variant="primary"
          onClick={() =>
            router.push(`/contract-management?tab=${TAB.contract.index}`)
          }
        >
          契約管理画面へ
        </Button>
      </div>
    </MainTemplate>
  );
};

const button = css({
  marginTop: "40px",
  textAlign: "center",
});
